(function(window) {
	
	'use strict';
	
		// @NOTE: Entirely vanilla JS.
	
	var colorCanvas;
	var colorCursor;
	var hueCanvas;
	var hueCursor;
	var currentColorCtn;
	
	var currentColor;
	var hueColor;
	var colorInput;
	
	var hue = 0;
	var saturation = 1;
	var light = 0.5;
	
	var lang = document.documentElement.lang;
	
	/**
	 * EXPOSED FUNCTIONS 
	 */
	var init = function () {
		if(document.getElementById('mg2ColorPicker')) {
			colorCanvas = document.getElementById('mg2ColorPicker');
			colorCursor = document.getElementById('mg2ColorCursor');
			hueCanvas = document.getElementById('mg2HuePicker');
			hueCursor = document.getElementById('mg2HueCursor');
			currentColorCtn = document.querySelector('.mg2-color-current');
			
			currentColorCtn.setAttribute('data-copy-text', currentColorCtn.getAttribute('data-copy-' + lang));
			currentColor = hueColor = colorCanvas.getAttribute('data-color');
			
			clearCanvasListeners();
			setupHueCanvas();
			setupCanvasListeners();
			setColor(currentColor);
		}
	};
	
	var getColor = function() {
		return currentColor;
	};
	
	var setColor = function(hex) {
		var hexVal = hex.charAt(0) === '#' ? hex.substr(1) : hex;
		var r = parseInt(hexVal.substr(0,2), 16);
		var g = parseInt(hexVal.substr(2,2), 16);
		var b = parseInt(hexVal.substr(4,2), 16);
		var hslValues = rgbToHsl(r, g, b);
		var hsvValue, hsvSaturation;
		
		currentColor = hex;
		hue = hslValues[0] * 360;
		saturation = hslValues[1];
		light = hslValues[2];
		hsvValue = (light * 2 + saturation * (1 - Math.abs(light * 2 - 1))) / 2;
		hsvSaturation = hsvValue !== 0 ? (2 * (hsvValue - light)) / hsvValue : 0;
		hueColor = 'hsl(' + hue + ', 100%, 50%)';
		
		setupColorCanvas();
		updateHue(hslValues[0] * hueCanvas.height);
		updateColor(hsvSaturation * colorCanvas.width, (1 - hsvValue) * colorCanvas.height);
	};
	/**
	 * END OF EXPOSED FUNCTIONS 
	 */
	
	/**
	 * FUNCTIONS TAKEN FROM: http://axonflux.com/handy-rgb-to-hsl-and-rgb-to-hsv-color-model-c 
	 */
	var hslToRgb = function() {
		var r, g, b;
		var h = hue / 360, s = !isNaN(saturation) ? saturation : 1, l = light;

		if(s === 0){
				r = g = b = l; // achromatic
		}else{
				var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
				var p = 2 * l - q;
				r = hue2rgb(p, q, h + 1/3);
				g = hue2rgb(p, q, h);
				b = hue2rgb(p, q, h - 1/3);
		}

		return '#' + numToHex(Math.round(r * 255)) + numToHex(Math.round(g * 255)) + numToHex(Math.round(b * 255));
	};
	
	var hue2rgb = function(p, q, t){
			if(t < 0) t += 1;
			if(t > 1) t -= 1;
			if(t < 1/6) return p + (q - p) * 6 * t;
			if(t < 1/2) return q;
			if(t < 2/3) return p + (q - p) * (2/3 - t) * 6;
			return p;
	};
	
	var rgbToHsl = function(r, g, b) {
		var max, min, h, s, l;
		
    r /= 255;
		g /= 255;
		b /= 255;
    max = Math.max(r, g, b);
		min = Math.min(r, g, b);
    l = (max + min) / 2;

    if(max == min){
        h = s = 0; // achromatic
    }else{
        var d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        switch(max){
            case r: h = (g - b) / d + (g < b ? 6 : 0); break;
            case g: h = (b - r) / d + 2; break;
            case b: h = (r - g) / d + 4; break;
        }
        h /= 6;
    }

    return [h, s, l];
	};
	/**
	 * END OF FUNCTIONS TAKEN FROM: http://axonflux.com/handy-rgb-to-hsl-and-rgb-to-hsv-color-model-c 
	 */
	
	/**
	 * UTILITY FUNCTIONS
	 */
	var numToHex = function(num) {
		var val = num.toString(16);
		return val.length === 1 ? 0 + val : val;
	};
	
	var clampValue = function(val, min, max) {
		return Math.min(Math.max(val, min), max);
	};
	
	var triggerCustomEvent = function(eventName) {
		var event = new Event(eventName); // no IE11 support
		document.getElementById('mg2ColorPicker').dispatchEvent(event);
	};
	/**
	 * END OF UTILITY FUNCTIONS
	 */
	
	var clearCanvasListeners = function() {
		colorCanvas.removeEventListener('mousedown', startDragColor);
		hueCanvas.removeEventListener('mousedown', startDragHue);
	};
	
	var setupCanvasListeners = function() {
		colorCanvas.addEventListener('mousedown', startDragColor);
		hueCanvas.addEventListener('mousedown', startDragHue);
		currentColorCtn.addEventListener('click', copyColor);
	};

	var setupColorCanvas = function() {
		var ctx = colorCanvas.getContext('2d');
		
		paintColorCanvas(ctx);
	};
	
	var paintColorCanvas = function(ctx) {
		ctx.fillStyle = hueColor;
		ctx.fillRect(0, 0, colorCanvas.width, colorCanvas.height);
		
		paintWhiteGradient(ctx);
		paintBlackGradient(ctx);
	};
	
	var paintWhiteGradient = function(ctx) {
		var whiteGradient = ctx.createLinearGradient(0,0,colorCanvas.width,0);
		whiteGradient.addColorStop(0, '#fff');
		whiteGradient.addColorStop(1, 'transparent');
		ctx.fillStyle = whiteGradient;
		ctx.fillRect(0, 0, colorCanvas.width, colorCanvas.height);
	};
	
	var paintBlackGradient = function(ctx) {
		var blackGradient = ctx.createLinearGradient(0,0,0,colorCanvas.height);
		blackGradient.addColorStop(0, 'transparent');
		blackGradient.addColorStop(1, '#000');
		ctx.fillStyle = blackGradient;
		ctx.fillRect(0, 0, colorCanvas.width, colorCanvas.height);
	};

	var setupHueCanvas = function() {
		var ctx = hueCanvas.getContext('2d');
		var gradient = ctx.createLinearGradient(0, 0, 0, hueCanvas.height);
		
		gradient.addColorStop(0,'hsl(0, 100%, 50%)');
		gradient.addColorStop(0.17,'hsl(61.2, 100%, 50%)');
		gradient.addColorStop(0.33,'hsl(118.8, 100%, 50%)');
		gradient.addColorStop(0.50,'hsl(180, 100%, 50%)');
		gradient.addColorStop(0.67,'hsl(241.2, 100%, 50%)');
		gradient.addColorStop(0.83,'hsl(298.8, 100%, 50%)');
		gradient.addColorStop(1,'hsl(360, 100%, 50%)');
		
		ctx.fillStyle = gradient;
		ctx.fillRect(0, 0, hueCanvas.width, hueCanvas.height);
	};

	var startDragColor = function(e) {
		e.preventDefault();
		
		moveDragColor(e);
		
		window.addEventListener('mousemove', moveDragColor);
		window.addEventListener('mouseup', stopDragColor);
	};
	
	var moveDragColor = function(e) {
		var rect = colorCanvas.getBoundingClientRect();
		var positionX = e.clientX - rect.left;
		var positionY = e.clientY - rect.top;
		var clampedX = clampValue(positionX, 0, colorCanvas.width);
		var clampedY = clampValue(positionY, 0, colorCanvas.height);
		
		updateColor(clampedX, clampedY);
	};
	
	var stopDragColor = function(e) {
		window.removeEventListener('mousemove', moveDragColor);
		window.removeEventListener('mouseup', stopDragColor);
	};
	
	// @NOTE: HSL calculations based on http://codeitdown.com/hsl-hsb-hsv-color/.
	var updateColor = function(x, y) {
		var ctx = colorCanvas.getContext('2d');
		var hsvValue, hsvSaturation;
		
		hsvValue = 1 - y / colorCanvas.height;
		hsvSaturation = x / colorCanvas.width; 
		light = (hsvValue / 2) * (2 - hsvSaturation);
		saturation = (hsvValue * hsvSaturation) / (1 - Math.abs(light * 2 - 1));
		currentColor = hslToRgb();
		
		currentColorCtn.style.background = currentColor;
		currentColorCtn.innerHTML = currentColor;
		
		colorCursor.style.top = y + "px";
		colorCursor.style.left = x + "px";
		colorCursor.style.background = currentColor;
		
		colorCursor.setAttribute('data-x', x);
		colorCursor.setAttribute('data-y', y);
		
		// triggerCustomEvent('colorupdate');
	};

	var startDragHue = function(e) {
		e.preventDefault();
		
		moveDragHue(e);
		
		window.addEventListener('mousemove', moveDragHue);
		window.addEventListener('mouseup', stopDragHue);
	};

	var moveDragHue = function(e) {
		var rect = hueCanvas.getBoundingClientRect();
		var positionY = e.clientY - rect.top;
		var clampedY = clampValue(positionY, 0, hueCanvas.height);
		
		updateHue(clampedY);
	};

	var stopDragHue = function(e) {
		window.removeEventListener('mousemove', moveDragHue);
		window.removeEventListener('mouseup', stopDragHue);
	};
	
	var updateHue = function(y) {
		var ctx = hueCanvas.getContext('2d');
		var colorX = colorCursor.getAttribute('data-x') | 0;
		var colorY = colorCursor.getAttribute('data-y') | 0;
		
		hue = y / hueCanvas.height * 360;
		
		hueColor = 'hsl(' + hue + ', 100%, 50%)';
		paintColorCanvas(colorCanvas.getContext('2d'));
		updateColor(colorX, colorY);
		
		hueCursor.style.top = y + "px";
		hueCursor.style.background = hueColor;
	};
	
	var copyColor = function(e) {
		var copySupported = document.queryCommandSupported('copy');
		var currentlyFocusedElement = document.activeElement;
		
		if(copySupported) {
			var input = document.createElement('input');
			input.setAttribute('value', currentColor);
			currentColorCtn.appendChild(input);
			input.select();
			document.execCommand('copy');
			currentlyFocusedElement.focus();
			currentColorCtn.removeChild(input);
			currentColorCtn.classList.add('copied');
            updateDataInput(currentColor);
			setTimeout(function() {
				currentColorCtn.classList.remove('copied');
			}, 2000);
		}
	};
    
    var updateDataInput = function(c){
    	var parent = $(currentColorCtn).closest('.popup-outer-ctn');
        var inpName = $(currentColorCtn).attr("data-inp");
        var inp = $("input[name="+inpName+"]", parent);
        
        inp.attr("value",c);
        inp.css("background-color",c);
        
        var luminance = {r: 0.2126, g: 0.7152, b: 0.0722};
        var color = c; // your color
        var r = parseInt(color.substring(1, 3), 16);
        var g = parseInt(color.substring(3, 5), 16);
        var b = parseInt(color.substring(5), 16);
        var rgb = [r / 255, g / 255, b / 255];
        for (var i = rgb.length; i--; )
            rgb[i] =
                    rgb[i] <= 0.03928 ?
                    rgb[i] / 12.92 :
                    Math.pow(((rgb[i] + 0.055) / 1.055), 2.4);
        var thresh = ((luminance.r * rgb[0]) +
                (luminance.g * rgb[1]) +
                (luminance.b * rgb[2]));
        
        if(thresh > 0.22){
            inp.css("color","black");            
            inp.css("border-color","black");            
        }else{
            inp.css("color","white");             
            inp.css("border-color","white");             
        }
        
    };

	window.MG2 = window.MG2 || {};
	window.MG2.ColorPicker = window.MG2.ColorPicker || {
		init: init,
		getColor: getColor,
		setColor: setColor
	};

})(window);
